const addToMoodboardButton = document.querySelector('.add-to-moodboard-button');
const addToMoodboardLink = addToMoodboardButton?.querySelector('#addToMoodboardLink');
const addToMoodboardLinkText = addToMoodboardLink?.querySelector('p');

const moodboardAddLookButtonStyleChange = () => {
    addToMoodboardLinkText.innerText = Translator.trans('viewer.choose_moodboard');

    addToMoodboardButton.classList.add('add-to-moodboard-button-clicked');
    addToMoodboardButton.classList.remove('add-to-moodboard-button-hover');

    addToMoodboardButton.addEventListener('mouseleave', () => {
        addToMoodboardLink.style.opacity = '1';
    });
}

const moodboardAddLookButtonStyleRollBack = () => {

    addToMoodboardButton.classList.remove('add-to-moodboard-button-clicked');
    addToMoodboardButton.classList.remove('add-to-moodboard-button-added');
    addToMoodboardButton.classList.add('add-to-moodboard-button-hover');

    addToMoodboardButton.addEventListener('mouseenter', () => {
        addToMoodboardLink.style.opacity = '1';
    })

    addToMoodboardButton.addEventListener('mouseleave', () => {
        addToMoodboardLink.style.opacity = '0';
    })
    addToMoodboardLinkText.innerText = Translator.trans('viewer.save');
}

const moodboardAddLookButtonDone = () => {

    addToMoodboardButton.classList.add('add-to-moodboard-button-added');
    addToMoodboardButton.classList.remove('add-to-moodboard-button-clicked');

    addToMoodboardLinkText.innerText = Translator.trans('viewer.saved');
}

export {moodboardAddLookButtonStyleRollBack, moodboardAddLookButtonStyleChange, moodboardAddLookButtonDone}
